exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".txt-blue[_v-b633039c]{color:#00e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-b633039c&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/orders/index.vue
// module id = 371
// module chunks = 0